
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/get-our-app",
      function () {
        return require("private-next-pages/get-our-app/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/get-our-app"])
      });
    }
  